module.exports = __webpack_public_path__ + "img/walk.e83fb2c4.png";